import {
  ADMIN_GROUP_GET_ALL_DATA,
  ADMIN_GROUP_GET_BY_ID_DATA,
  ADMIN_GROUP_ADD_DATA,
  ADMIN_GROUP_UPDATE_DATA,
  ADMIN_GROUP_DELETE_DATA,
  ADMIN_GROUP_GET_DATA,
  ADMIN_GROUP_UPDATE_FLAG_DATA,
} from "./Constants";

// Get All
const loadAdminGroupGetAllRequest = (request) => ({
  type: ADMIN_GROUP_GET_ALL_DATA.ADMIN_GROUP_GET_ALL_LOAD,
  request,
});
const setAdminGroupGetAllSuccess = (adminGroups) => ({
  type: ADMIN_GROUP_GET_ALL_DATA.ADMIN_GROUP_GET_ALL_SUCCESS,
  adminGroups,
});
const setAdminGroupGetAllFail = (error) => ({
  type: ADMIN_GROUP_GET_ALL_DATA.ADMIN_GROUP_GET_ALL_FAIL,
  error,
});

// Get By ID
const loadAdminGroupGetByIdRequest = (id) => ({
  type: ADMIN_GROUP_GET_BY_ID_DATA.ADMIN_GROUP_GET_BY_ID_LOAD,
  id,
});
const setAdminGroupGetByIdSuccess = (groupDetails) => ({
  type: ADMIN_GROUP_GET_BY_ID_DATA.ADMIN_GROUP_GET_BY_ID_SUCCESS,
  groupDetails,
});
const setAdminGroupGetByIdFail = (error) => ({
  type: ADMIN_GROUP_GET_BY_ID_DATA.ADMIN_GROUP_GET_BY_ID_FAIL,
  error,
});

// Add
const loadAdminGroupAddDataRequest = (id,request) => ({
  type: ADMIN_GROUP_ADD_DATA.ADMIN_GROUP_ADD_DATA_LOAD,
  id, request,
});
const setAdminGroupAddDataSuccess = (adminGroup) => ({
  type: ADMIN_GROUP_ADD_DATA.ADMIN_GROUP_ADD_DATA_SUCCESS,
  adminGroup,
});
const setAdminGroupAddDataFail = (error) => ({
  type: ADMIN_GROUP_ADD_DATA.ADMIN_GROUP_ADD_DATA_FAIL,
  error,
});

// Update
const loadAdminGroupUpdateDataRequest = (request) => ({
  type: ADMIN_GROUP_UPDATE_DATA.ADMIN_GROUP_UPDATE_DATA_LOAD,
  request,
});
const setAdminGroupUpdateDataSuccess = (adminGroup) => ({
  type: ADMIN_GROUP_UPDATE_DATA.ADMIN_GROUP_UPDATE_DATA_SUCCESS,
  adminGroup,
});
const setAdminGroupUpdateDataFail = (error) => ({
  type: ADMIN_GROUP_UPDATE_DATA.ADMIN_GROUP_UPDATE_DATA_FAIL,
  error,
});
const resetAdminGroupUpdateData = () => ({
  type: ADMIN_GROUP_UPDATE_DATA.ADMIN_GROUP_UPDATE_DATA_RESET,
});

// Delete
const loadAdminGroupDeleteDataRequest = (payload) => ({
  type: ADMIN_GROUP_DELETE_DATA.ADMIN_GROUP_DELETE_LOAD,
  payload,
});
const setAdminGroupDeleteDataSuccess = (adminGroup) => ({
  type: ADMIN_GROUP_DELETE_DATA.ADMIN_GROUP_DELETE_SUCCESS,
  adminGroup,
});
const setAdminGroupDeleteDataFail = (error) => ({
  type: ADMIN_GROUP_DELETE_DATA.ADMIN_GROUP_DELETE_FAIL,
  error,
});

//To Get Admin group all
  const loadAdminGroupGetDataRequest = () => ({
    type: ADMIN_GROUP_GET_DATA.ADMIN_GROUP_GET_DATA_LOAD,
  });

  const setAdminGroupGetDataSuccess = (adminGroupAll) => ({
    type: ADMIN_GROUP_GET_DATA.ADMIN_GROUP_GET_DATA_SUCCESS,
    adminGroupAll,
  });

  const setAdminGroupGetDataFail = (error) => ({
    type: ADMIN_GROUP_GET_DATA.ADMIN_GROUP_GET_DATA_FAIL,
    error,
  });

// Update Admin Flag
const loadAdminGroupUpdateFlagRequest = (request) => ({
  type: ADMIN_GROUP_UPDATE_FLAG_DATA.ADMIN_GROUP_UPDATE_FLAG_LOAD,
  request,
});
const setAdminGroupUpdateFlagSuccess = (data) => ({
  type: ADMIN_GROUP_UPDATE_FLAG_DATA.ADMIN_GROUP_UPDATE_FLAG_SUCCESS,
  data,
});
const setAdminGroupUpdateFlagFail = (error) => ({
  type: ADMIN_GROUP_UPDATE_FLAG_DATA.ADMIN_GROUP_UPDATE_FLAG_FAIL,
  error,
});
const resetAdminGroupUpdateFlag = () => ({
  type: ADMIN_GROUP_UPDATE_FLAG_DATA.ADMIN_GROUP_UPDATE_FLAG_RESET,
});

export {
  loadAdminGroupGetAllRequest, setAdminGroupGetAllSuccess, setAdminGroupGetAllFail,
  loadAdminGroupGetByIdRequest, setAdminGroupGetByIdSuccess, setAdminGroupGetByIdFail,
  loadAdminGroupAddDataRequest, setAdminGroupAddDataSuccess, setAdminGroupAddDataFail,
  loadAdminGroupUpdateDataRequest, setAdminGroupUpdateDataSuccess, setAdminGroupUpdateDataFail, resetAdminGroupUpdateData,
  loadAdminGroupDeleteDataRequest, setAdminGroupDeleteDataSuccess, setAdminGroupDeleteDataFail,
  loadAdminGroupGetDataRequest, setAdminGroupGetDataSuccess, setAdminGroupGetDataFail,
  loadAdminGroupUpdateFlagRequest, setAdminGroupUpdateFlagSuccess, setAdminGroupUpdateFlagFail, resetAdminGroupUpdateFlag,
};